enum SaveState {
  Unsaved = 'unsaved',
  Saving = 'saving',
  Saved = 'saved'
}

export default SaveState;



// WEBPACK FOOTER //
// ./src/state/SaveState.ts